import React from 'react';
import { Box, Typography } from '@mui/material';
import Header from "../../assets/image/Header.png";

const HeaderComponent = ({ title = "Header" }) => {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '350px',
        height: '38px',
        position: 'relative',
        mt: -3.2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        backgroundColor: "lightblue.main"
      }}
    >
      <Box
        component="img"
        src={Header}
        alt="Header Background"
        sx={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          position: 'absolute',
          top: 0,
          left: 0,
          zIndex: 1
        }}
      />
      <Typography
        variant="button"
        sx={{
          position: 'relative',
          zIndex: 2,
          color: 'primary.main',
          fontWeight: 'bold',
          textAlign: 'center',
          textTransform:"none",
          px: 1,
          mr:6,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: {
            xs: '0.75rem',
            sm: '0.875rem',
            md: '1rem'
          }
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};

export default HeaderComponent;
